import { addSeconds, format } from 'date-fns';

export const formatTime = (seconds: number) => {
  if (!Number.isFinite(seconds) || seconds < 0 || Number.isNaN(seconds)) {
    return '00:00';
  }

  const helperDate = addSeconds(new Date(0), seconds);
  return format(helperDate, 'mm:ss');
};
